module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-countdown u-relative"
  }, [(_vm.countdown.days > 0) ? _c('div', {
    staticClass: "c-countdown--days u-marg-x-auto u-flex u-align-center"
  }, [_c('div', {
    staticClass: "u-relative"
  }, [_c('span', {
    staticClass: "c-countdown__label u-relative u-block t-fsize--xxs u-uppercase u-color--text u-align-left"
  }, [_vm._v("/ days")]), _vm._v(" "), _c('span', {
    staticClass: "c-countdown__number u-relative u-flex t-ffamily--simplon t-fweight--medium u-color--text u-force-3d"
  }, [_c('div', {
    staticClass: "c-countdown__number__single--1 u-relative"
  }, [_vm._v(_vm._s(_vm.countdown.daysSplitted[0]))]), _vm._v(" "), _c('div', {
    staticClass: "c-countdown__number__single--2 u-relative"
  }, [_vm._v(_vm._s(_vm.countdown.daysSplitted[1]))])])]), _vm._v(" "), _c('div', {
    staticClass: "u-relative u-marg-l-lg u-marg-l-md@md u-marg-l-sm@sm"
  }, [_c('span', {
    staticClass: "c-countdown__label u-relative u-block t-fsize--xxs u-uppercase u-color--text u-align-left"
  }, [_vm._v("/ hours")]), _vm._v(" "), _c('span', {
    staticClass: "c-countdown__number u-relative u-flex t-ffamily--simplon t-fweight--medium u-color--text u-force-3d"
  }, [_c('div', {
    staticClass: "c-countdown__number__single--3 u-relative"
  }, [_vm._v(_vm._s(_vm.countdown.hoursSplitted[0]))]), _vm._v(" "), _c('div', {
    staticClass: "c-countdown__number__single--4 u-relative"
  }, [_vm._v(_vm._s(_vm.countdown.hoursSplitted[1]))])])]), _vm._v(" "), _c('div', {
    staticClass: "u-relative u-marg-l-lg u-marg-l-md@md u-marg-l-sm@sm"
  }, [_c('span', {
    staticClass: "c-countdown__label u-relative u-block t-fsize--xxs u-uppercase u-color--text u-align-left"
  }, [_vm._v("/ minutes")]), _vm._v(" "), _c('span', {
    staticClass: "c-countdown__number u-relative u-flex t-ffamily--simplon t-fweight--medium u-color--text u-force-3d"
  }, [_c('div', {
    staticClass: "c-countdown__number__single--5 u-relative"
  }, [_vm._v(_vm._s(_vm.countdown.minutesSplitted[0]))]), _vm._v(" "), _c('div', {
    staticClass: "c-countdown__number__single--6 u-relative"
  }, [_vm._v(_vm._s(_vm.countdown.minutesSplitted[1]))])])])]) : (!_vm.finished) ? _c('div', {
    staticClass: "c-countdown--hours u-marg-x-auto u-flex u-align-center"
  }, [_c('div', {
    staticClass: "u-relative"
  }, [_c('span', {
    staticClass: "c-countdown__label u-relative u-block t-fsize--xxs u-uppercase u-color--text u-align-left"
  }, [_vm._v("/ hours")]), _vm._v(" "), _c('span', {
    staticClass: "c-countdown__number u-relative u-flex t-ffamily--simplon t-fweight--medium u-color--text u-force-3d"
  }, [_c('div', {
    staticClass: "c-countdown__number__single--1 u-relative"
  }, [_vm._v(_vm._s(_vm.countdown.hoursSplitted[0]))]), _vm._v(" "), _c('div', {
    staticClass: "c-countdown__number__single--2 u-relative"
  }, [_vm._v(_vm._s(_vm.countdown.hoursSplitted[1]))])])]), _vm._v(" "), _c('div', {
    staticClass: "u-relative u-marg-l-lg u-marg-l-md@md u-marg-l-sm@sm"
  }, [_c('span', {
    staticClass: "c-countdown__label u-relative u-block t-fsize--xxs u-uppercase u-color--text u-align-left"
  }, [_vm._v("/ minutes")]), _vm._v(" "), _c('span', {
    staticClass: "c-countdown__number u-relative u-flex t-ffamily--simplon t-fweight--medium u-color--text u-force-3d"
  }, [_c('div', {
    staticClass: "c-countdown__number__single--3 u-relative"
  }, [_vm._v(_vm._s(_vm.countdown.minutesSplitted[0]))]), _vm._v(" "), _c('div', {
    staticClass: "c-countdown__number__single--4 u-relative"
  }, [_vm._v(_vm._s(_vm.countdown.minutesSplitted[1]))])])]), _vm._v(" "), _c('div', {
    staticClass: "u-relative u-marg-l-lg u-marg-l-md@md u-marg-l-sm@sm"
  }, [_c('span', {
    staticClass: "c-countdown__label u-relative u-block t-fsize--xxs u-uppercase u-color--text u-align-left"
  }, [_vm._v("/ seconds")]), _vm._v(" "), _c('span', {
    staticClass: "c-countdown__number u-relative u-flex t-ffamily--simplon t-fweight--medium u-color--text u-force-3d"
  }, [_c('div', {
    staticClass: "c-countdown__number__single--5 u-relative"
  }, [_vm._v(_vm._s(_vm.countdown.secondsSplitted[0]))]), _vm._v(" "), _c('div', {
    staticClass: "c-countdown__number__single--6 u-relative"
  }, [_vm._v(_vm._s(_vm.countdown.secondsSplitted[1]))])])])]) : (_vm.finished) ? _c('div', {
    staticClass: "c-countdown--hours u-marg-x-auto u-flex u-align-center"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-relative"
  }, [_c('span', {
    staticClass: "c-countdown__label u-relative u-block t-fsize--xxs u-uppercase u-color--text u-align-left"
  }, [_vm._v("/ hours")]), _vm._v(" "), _c('span', {
    staticClass: "c-countdown__number u-relative u-flex t-ffamily--simplon t-fweight--medium u-color--text u-force-3d"
  }, [_c('div', {
    staticClass: "c-countdown__number__single--1 u-relative"
  }, [_vm._v("9")]), _vm._v(" "), _c('div', {
    staticClass: "c-countdown__number__single--2 u-relative"
  }, [_vm._v("9")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-relative u-marg-l-lg u-marg-l-md@md u-marg-l-sm@sm"
  }, [_c('span', {
    staticClass: "c-countdown__label u-relative u-block t-fsize--xxs u-uppercase u-color--text u-align-left"
  }, [_vm._v("/ minutes")]), _vm._v(" "), _c('span', {
    staticClass: "c-countdown__number u-relative u-flex t-ffamily--simplon t-fweight--medium u-color--text u-force-3d"
  }, [_c('div', {
    staticClass: "c-countdown__number__single--3 u-relative"
  }, [_vm._v("9")]), _vm._v(" "), _c('div', {
    staticClass: "c-countdown__number__single--4 u-relative"
  }, [_vm._v("9")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-relative u-marg-l-lg u-marg-l-md@md u-marg-l-sm@sm"
  }, [_c('span', {
    staticClass: "c-countdown__label u-relative u-block t-fsize--xxs u-uppercase u-color--text u-align-left"
  }, [_vm._v("/ seconds")]), _vm._v(" "), _c('span', {
    staticClass: "c-countdown__number u-relative u-flex t-ffamily--simplon t-fweight--medium u-color--text u-force-3d"
  }, [_c('div', {
    staticClass: "c-countdown__number__single--5 u-relative"
  }, [_vm._v("9")]), _vm._v(" "), _c('div', {
    staticClass: "c-countdown__number__single--6 u-relative"
  }, [_vm._v("9")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c0262d6"}!./src/scripts/components/app-countdown/template.html
// module id = 473
// module chunks = 0